module.exports = {};



//////////////////
// WEBPACK FOOTER
// C:/Users/Administrator/submit text project/gwin/~/._core-js@2.5.0@core-js/modules/_iterators.js
// module id = ../../../../._core-js@2.5.0@core-js/modules/_iterators.js
// module chunks = 2